// src/context/AuthContext.js
import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_API_URL } from '../helpers/Config';
import { TriggerBalanceUpdate } from '../helpers/TriggerBalanceUpdate';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(true);

    const checkAuth = async () => {
        const token = localStorage.getItem('a5srf4wer7w1cd');
        if (!token) return setIsAuthenticated(false);

        try {
            const res = await axios.post(`${BASE_API_URL}/auth/check-token`,
                {
                    token: token
                },
                {
                    timeout: 3000
                }
            );

            const data = res?.data;
            if (data?.error) {
                setIsAuthenticated(false);
                localStorage.removeItem("a5srf4wer7w1cd");
            } else {
                setIsAuthenticated(true);
                const balance = data?.balance;
                const usdt = data?.usdt;
                TriggerBalanceUpdate({ balance, usdt });
            }

        } catch (err) {
            if (err.code === 'ERR_NETWORK') {
                // Offline → keep session valid
                setIsAuthenticated(true);
            } else {
                // Token invalid → logout
                setIsAuthenticated(false);
            }
        }
    };

    useEffect(() => {
        // Run silently after page shows
        setTimeout(checkAuth, 0);

        // Optional: re-check when app gains focus
        window.addEventListener('focus', checkAuth);
        return () => window.removeEventListener('focus', checkAuth);
    }, []);

    return (
        <AuthContext.Provider value={{ isAuthenticated, checkAuth }}>
            {children}
        </AuthContext.Provider>
    );
};
